import React, { useState, useEffect, Fragment, memo } from 'react';
import { Card, Button, Alert } from 'react-bootstrap';
import { Table, Popconfirm, Select, Input } from 'antd';
import moment from 'moment';
import * as XLSX from 'xlsx';
import { uploadFiles, } from '../../../services/UploadService';
import { fileUploadStatusDataService, getAllAdminIECsService, deleteFileDataService, getPartNumberMasterDataService, getMasterHSNDataService } from '../../../services/FileDataService';

const deleteIcon = `
<svg width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor">
<path d="M19.3248 9.46826C19.3248 9.46826 18.7818 16.2033 18.4668 19.0403C18.3168 20.3953 17.4798 21.1893 16.1088 21.2143C13.4998 21.2613 10.8878 21.2643 8.27979 21.2093C6.96079 21.1823 6.13779 20.3783 5.99079 19.0473C5.67379 16.1853 5.13379 9.46826 5.13379 9.46826" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
<path d="M20.708 6.23975H3.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
<path d="M17.4406 6.23973C16.6556 6.23973 15.9796 5.68473 15.8256 4.91573L15.5826 3.69973C15.4326 3.13873 14.9246 2.75073 14.3456 2.75073H10.1126C9.53358 2.75073 9.02558 3.13873 8.87558 3.69973L8.63258 4.91573C8.47858 5.68473 7.80258 6.23973 7.01758 6.23973" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
</svg>
`;

const MasterCardComponent = ({ title }) => {
  const [file, setFile] = useState(null);
  const [fileUploadError, setFileUploadError] = useState(null);
  const [fileStatusDataList, setFileStatusDataList] = useState([]);
  const [IECOptions, setIECOptions] = useState([]);
  const [userRole] = useState(localStorage.getItem('role'));
  const [activeTab, setActiveTab] = useState('upload'); // 'upload' | 'data'

  // Data viewer state
  const [masterDataList, setMasterDataList] = useState([]);
  const [masterDataTotal, setMasterDataTotal] = useState(0);
  const [masterDataLoading, setMasterDataLoading] = useState(false);
  const [dataFilters, setDataFilters] = useState({ iec_no: '', part_number: '', hsn_code: '', hs_code: '' });
  const [dataPage, setDataPage] = useState(1);
  const PAGE_SIZE = 50;
  const [selectedIEC, setSelectedIEC] = useState(() => {
    if (title === "Part_Number" || title === "MASTER_HSN") {
      return [];
    } else {
      return localStorage.getItem('iec_no');
    }
  });
  const [lotType, setLotType] = useState(null);
  const [typeOptions, setTypeOptions] = useState([]);

  // 🔹 Handle file input
  const handleFileChange = (e) => {
    const files = e.target.files;
    if (files.length > 25) {
      alert('You cannot select more than 25 files');
      e.target.value = ''; // reset input
      return;
    }
    setFile(files);
  };

  console.log("selected iec: ", selectedIEC)

  const handleSubmit = async () => {
    try {
      if (!file) {
        setFileUploadError('Please select a file before uploading.');
        return;
      }

      if (title === 'Part_Number' || title === 'CCR' || title === 'MASTER_HSN') {
        if (!selectedIEC || (Array.isArray(selectedIEC) && selectedIEC.length === 0)) {
          setFileUploadError('Please select at least one IEC.');
          return;
        }
      }

      if (title === 'CCR' && !lotType) {
        setFileUploadError('Please select Type.');
        return;
      }

      const params = title === 'CCR' ? { file_category: lotType } : {};
      await uploadFiles(file, title, selectedIEC, params);
      setFileUploadError(null);
      if (title === 'Part_Number' || title === 'CCR' || title === 'MASTER_HSN') {
        setSelectedIEC(title === 'Part_Number' ? [] : localStorage.getItem('iec_no'));
        setSelectedIEC(title === 'MASTER_HSN' ? [] : localStorage.getItem('iec_no'));
        setLotType(null);
      }
      fetchFileUploadStatus();
    } catch (error) {
      console.error('Upload failed:', error);
      setFileUploadError('File upload failed. Please try again.');
    }
  };

  // 🔹 Delete file record
  const deleteFileRecord = async (record) => {
    try {
      const token = localStorage.getItem('token');
      const response = await deleteFileDataService(token, record.file_status_id);
      if (response) {
        fetchFileUploadStatus();
      }
    } catch (err) {
      console.error('Delete failed:', err);
    }
  };

  // 🔹 Fetch IEC options for superadmin
  const getAdminIEC = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await getAllAdminIECsService(token);
      if (response && response.data) {
        setIECOptions(
          response.data.map((item, i) => ({
            value: item.iec_no,
            label: `${item.iec_no} (${item.fullname})`,
            key: i,
          }))
        );
      }
    } catch (err) {
      console.error('Failed to fetch IEC list:', err);
    }
  };

  // 🔹 Fetch uploaded file data
  const fetchFileUploadStatus = async () => {
    try {
      setFileStatusDataList([]);
      const token = localStorage.getItem('token');
      const response = await fileUploadStatusDataService(title, token);
      if (response?.data) {
        setFileStatusDataList(response.data);
      }
    } catch (err) {
      console.error('Failed to fetch file upload status:', err);
    }
  };

  const handleLotTypeSelection = (val) => {
    setLotType(val || null);
  };

  const handleDropdownOpen = (open) => {
    if (!open) return;
    if (title === 'CCR') {
      setTypeOptions([
        { value: "IMPORT_CCR", label: "IMPORT_CCR" },
        { value: "EXPORT_CCR", label: "EXPORT_CCR" }
      ]);
    }
  };

  useEffect(() => {
    getAdminIEC();
    fetchFileUploadStatus();
    if (title === "Part_Number" || title === "MASTER_HSN") {
      setSelectedIEC([]);
    } else {
      setSelectedIEC(localStorage.getItem('iec_no'));
    }
  }, [title]);

  const fetchMasterData = async (page = 1, filters = dataFilters) => {
    if (title !== 'Part_Number' && title !== 'MASTER_HSN') return;
    setMasterDataLoading(true);
    try {
      let result;
      if (title === 'Part_Number') {
        result = await getPartNumberMasterDataService({
          iec_no: filters.iec_no || undefined,
          part_number: filters.part_number || undefined,
          hsn_code: filters.hsn_code || undefined,
          page,
          page_size: PAGE_SIZE,
        });
      } else {
        result = await getMasterHSNDataService({
          iec_no: filters.iec_no || undefined,
          part_number: filters.part_number || undefined,
          hs_code: filters.hs_code || undefined,
          page,
          page_size: PAGE_SIZE,
        });
      }
      setMasterDataList(result?.data || []);
      setMasterDataTotal(result?.total || 0);
    } catch (err) {
      console.error('Failed to fetch master data:', err);
    } finally {
      setMasterDataLoading(false);
    }
  };

  const handleDataFilterSearch = () => {
    setDataPage(1);
    fetchMasterData(1, dataFilters);
  };

  const handleDataPageChange = (page) => {
    setDataPage(page);
    fetchMasterData(page, dataFilters);
  };

  const partNumberDataColumns = [
    { title: 'IEC No', dataIndex: 'iec_no', width: 130 },
    { title: 'Part Number', dataIndex: 'part_number', width: 150 },
    { title: 'HSN Code', dataIndex: 'hsn_code', width: 120 },
    { title: 'Rate of Duty (%)', dataIndex: 'rate_of_duty', width: 140, render: (v) => v != null ? Number(v).toFixed(2) : '-' },
    { title: 'IGST Rate (%)', dataIndex: 'igst_rate', width: 120, render: (v) => v != null ? Number(v).toFixed(2) : '-' },
    { title: 'Country Code', dataIndex: 'country_code', width: 120 },
    { title: 'Active', dataIndex: 'is_active', width: 80, render: (v) => v ? '✅' : '❌' },
    { title: 'Updated At', dataIndex: 'updated_at', width: 140, render: (t) => t ? moment(t).format('DD-MM-YYYY') : '-' },
  ];

  const masterHSNDataColumns = [
    { title: 'IEC No', dataIndex: 'iec_no', width: 130 },
    { title: 'Part Number', dataIndex: 'part_number', width: 150 },
    { title: 'Description', dataIndex: 'description', width: 200 },
    { title: 'HS Code', dataIndex: 'hs_code', width: 120 },
    { title: 'Updated At', dataIndex: 'updated_at', width: 140, render: (t) => t ? moment(t).format('DD-MM-YYYY') : '-' },
  ];

  const handleDownloadFormat = () => {
    let columns = [];
    const wb = XLSX.utils.book_new();

    switch (title) {
      case 'BR_Corelation':
        columns = ["Sr. No.", "Branch Code", "Business Unit", "Plant Name", "DTA/SEZ"];
        const wsBR = XLSX.utils.aoa_to_sheet([columns]);
        XLSX.utils.book_append_sheet(wb, wsBR, "0123456789"); // sample IEC sheet name
        break;
      case 'Part_Number':
        columns = ["Part No.", "HSN Code", "Rate of Duty", "IGST rate %", "Country"];
        const wsPN = XLSX.utils.aoa_to_sheet([columns]);
        XLSX.utils.book_append_sheet(wb, wsPN, "Template");
        break;
      case 'MASTER_HSN':
        columns = ["PART NO", "DESCRIPTION", "HS CODE"];
        const wsHSN = XLSX.utils.aoa_to_sheet([columns]);
        XLSX.utils.book_append_sheet(wb, wsHSN, "Template");
        break;
      case 'CCR':
        columns = ["HSN Code", "CCR", "Policy"];
        const wsCCR = XLSX.utils.aoa_to_sheet([columns]);
        XLSX.utils.book_append_sheet(wb, wsCCR, "Template");
        break;
      case 'USD_EX_RATE':
        columns = ["Date", "USD Ex. Rate", "EUR Ex. Rate", "GBP Ex. Rate", "JPY Ex. Rate", "CNY Ex. Rate", "CHF Ex. Rate", "AUD Ex. Rate", "CAD Ex. Rate", "HKD Ex. Rate"];
        const wsImport = XLSX.utils.aoa_to_sheet([columns]);
        const wsExport = XLSX.utils.aoa_to_sheet([columns]);
        XLSX.utils.book_append_sheet(wb, wsImport, "IMPORT");
        XLSX.utils.book_append_sheet(wb, wsExport, "EXPORT");
        break;
      default:
        columns = ["Column1", "Column2"];
        const wsDef = XLSX.utils.aoa_to_sheet([columns]);
        XLSX.utils.book_append_sheet(wb, wsDef, "Template");
    }

    XLSX.writeFile(wb, `${title}_Format.xlsx`);
  };

  const fileUploadStatusColumns = [
    {
      title: 'Action',
      dataIndex: 'iconAction',
      width: 80,
      render: (_, record) => (
        <Popconfirm
          title="Delete this file record?"
          onConfirm={() => deleteFileRecord(record)}
          okText="Yes"
          cancelText="No"
        >
          <a className="btn btn-sm btn-icon btn-danger" data-toggle="tooltip" data-placement="top" title="" data-original-title="Delete" to="#">
            <span
              className="btn-inner"
              dangerouslySetInnerHTML={{ __html: deleteIcon }}
            />
          </a>
        </Popconfirm>
      ),
    },
    {
      title: 'File Name',
      dataIndex: 'filename',
      width: 320,
    },
    {
      title: 'User IEC',
      dataIndex: 'user_iec_no',
      width: 120,
    },
    {
      title: 'IEC Name',
      dataIndex: 'fullname',
      width: 250,
    },
    {
      title: 'File Status',
      dataIndex: 'status',
      width: 120,
    },
    {
      title: 'Remark',
      dataIndex: 'remarks',
      width: 150,
    },
    {
      title: 'Uploaded on',
      dataIndex: 'created_at',
      width: 130,
      render: (text) => moment(text).format('DD-MM-YYYY'),
    },
  ];

  return (
    <Fragment>
      <Card>
        <Card.Body>
          <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
            <Card.Title className="mb-0">{title}</Card.Title>
            {(title === 'Part_Number' || title === 'MASTER_HSN') && (
              <div className="d-flex gap-2">
                <Button
                  variant={activeTab === 'upload' ? 'primary' : 'outline-secondary'}
                  size="sm"
                  onClick={() => setActiveTab('upload')}
                >
                  <i className="fa-solid fa-cloud-arrow-up me-1"></i> Upload
                </Button>
                <Button
                  variant={activeTab === 'data' ? 'primary' : 'outline-secondary'}
                  size="sm"
                  onClick={() => { setActiveTab('data'); fetchMasterData(1, dataFilters); }}
                >
                  <i className="fa-solid fa-table me-1"></i> View Data
                </Button>
              </div>
            )}
          </div>

          {activeTab === 'upload' && (
            <>
              <div className="d-flex align-items-center flex-wrap gap-2">
                <input
                  onChange={handleFileChange}
                  className="file-input"
                  type="file"
                  multiple
                  style={{ width: '250px' }}
                />
                {title === 'CCR' && (
                  <Select
                    showSearch
                    placeholder="Select Type"
                    onChange={handleLotTypeSelection}
                    onDropdownVisibleChange={handleDropdownOpen}
                    value={lotType}
                    allowClear
                    options={typeOptions}
                    style={{ width: '180px' }}
                  />
                )}
                {(title === 'Part_Number' || title === 'CCR' || title === 'MASTER_HSN') && (
                  <Select
                    mode={title === 'Part_Number' || title === 'MASTER_HSN' ? "multiple" : undefined}
                    showSearch
                    placeholder={title === 'Part_Number' || title === 'MASTER_HSN' ? "Select IEC(s)" : "Select IEC"}
                    filterOption={(input, option) =>
                      (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                    }
                    onChange={(val) => setSelectedIEC(val)}
                    value={selectedIEC}
                    allowClear
                    options={IECOptions}
                    style={{ width: '300px' }}
                  />
                )}

                <Button
                  title="Select a file and then upload"
                  onClick={handleSubmit}
                  style={{ padding: '5px 20px' }}
                  className="upload-btn"
                >
                  <i className="fa-solid fa-cloud-arrow-up"></i> Upload
                </Button>

                <Button
                  variant="outline-primary"
                  title="Download Excel format template"
                  onClick={handleDownloadFormat}
                  style={{ padding: '5px 20px' }}
                >
                  <i className="fa-solid fa-download"></i> Format
                </Button>
              </div>

              {fileUploadError && (
                <Alert variant="danger" className="mt-3">
                  {fileUploadError}
                </Alert>
              )}

              <div className="table-responsive mt-3">
                <Table
                  columns={fileUploadStatusColumns}
                  dataSource={fileStatusDataList}
                  pagination={{ pageSize: 10 }}
                  rowKey="file_status_id"
                  scroll={{ x: 'max-content' }}
                />
              </div>
            </>
          )}

          {/* ── DATA TAB ── */}
          {activeTab === 'data' && (title === 'Part_Number' || title === 'MASTER_HSN') && (
            <>
              <div className="d-flex align-items-center flex-wrap gap-2 mb-3">
                {userRole === 'superadmin' && (
                  <Select
                    showSearch
                    placeholder="Filter by IEC"
                    filterOption={(input, option) =>
                      (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                    }
                    onChange={(val) => setDataFilters(f => ({ ...f, iec_no: val || '' }))}
                    value={dataFilters.iec_no || undefined}
                    allowClear
                    options={IECOptions}
                    style={{ width: '260px' }}
                  />
                )}
                <Input
                  placeholder="Filter by Part Number"
                  value={dataFilters.part_number}
                  onChange={(e) => setDataFilters(f => ({ ...f, part_number: e.target.value }))}
                  onPressEnter={handleDataFilterSearch}
                  style={{ width: '200px' }}
                  allowClear
                />
                {title === 'Part_Number' && (
                  <Input
                    placeholder="Filter by HSN Code"
                    value={dataFilters.hsn_code}
                    onChange={(e) => setDataFilters(f => ({ ...f, hsn_code: e.target.value }))}
                    onPressEnter={handleDataFilterSearch}
                    style={{ width: '180px' }}
                    allowClear
                  />
                )}
                {title === 'MASTER_HSN' && (
                  <Input
                    placeholder="Filter by HS Code"
                    value={dataFilters.hs_code}
                    onChange={(e) => setDataFilters(f => ({ ...f, hs_code: e.target.value }))}
                    onPressEnter={handleDataFilterSearch}
                    style={{ width: '180px' }}
                    allowClear
                  />
                )}
                <Button variant="primary" size="sm" onClick={handleDataFilterSearch}>
                  <i className="fa-solid fa-magnifying-glass me-1"></i> Search
                </Button>
              </div>

              <div className="table-responsive">
                <Table
                  columns={title === 'Part_Number' ? partNumberDataColumns : masterHSNDataColumns}
                  dataSource={masterDataList}
                  loading={masterDataLoading}
                  rowKey={title === 'Part_Number' ? 'part_number_id' : 'id'}
                  scroll={{ x: 'max-content' }}
                  pagination={{
                    current: dataPage,
                    pageSize: PAGE_SIZE,
                    total: masterDataTotal,
                    onChange: handleDataPageChange,
                    showSizeChanger: false,
                    showTotal: (total) => `Total ${total} records`,
                  }}
                />
              </div>
            </>
          )}
        </Card.Body>
      </Card>
    </Fragment>
  );
};

export default memo(MasterCardComponent);

